// extracted by mini-css-extract-plugin
export default {"container":"MessagePhoneCall_container__irnfh"};